import { useState } from "react";
import { iconsDetailsProyect } from "../../../../assets/icons/detailsProject";
import { TableGeneral } from "../../../../components/table/TableGeneral";
import { columnsUpdateHoursProject } from "../../../../types/columnsTables/columnUpdateHours";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";
import CardProjectFiche from "./CardProjectFiche";


const CardUpdatedHours = ({ backups, isAdmin, isSuperAdmin, activeModalDetailsProject, deleteRow }) => {
    const [isLoading, setIsLoading] = useState(false)

    const editForm = (e) => {
        const { afterHours, amount, currency, comment, key } = e;
        const areaNameInput = {
            art3d: "modelingHours",
            desing: "designHours",
            planning: "planningHours",
            unity: "unityHours",
            web: "webHours",
            testing: "testingHours",
        };

        const formatFormArea = Object.entries(afterHours).map(([key, value]) => [areaNameInput[key], value]);

        let formUpdateHours = {
            ...Object.fromEntries(formatFormArea),
            amount,
            currency,
            comment,
        };

        activeModalDetailsProject(typeForDetailsProyect.updateHrs, {
            type: 1,
            idSelect: key,
            dataForm: formUpdateHours,
            title: "Editar ajuste de horas",
        });
    }

    const deleteData = async (key) => {
        setIsLoading(true)
        await deleteRow(typeForDetailsProyect.deleteAdjustmentOfHours, { adjustmentOfHoursId: key });
        setIsLoading(false)
    }

    const { columns: columnsUpdateHours, props: propsUpdateHours } = columnsUpdateHoursProject(
        editForm,
        deleteData,
        backups?.length - 1,
        { isAdmin: isAdmin, isSuperAdmin: isSuperAdmin }
    );

    return (
        <CardProjectFiche
            title="Ajuste de horas"
            enableButtonExtra={isSuperAdmin || isAdmin}
            buttonExtra={
                <div
                    onClick={() => {
                        activeModalDetailsProject(typeForDetailsProyect.updateHrs, {
                            type: 0,
                            title: "Agregar Ajuste de horas",
                        });
                    }}
                    className="h-full w-[15px] cursor-pointer"
                >
                    <img className="h-full w-full object-contain" src={iconsDetailsProyect.editbutton} alt="edit" />
                </div>
            }
        >
            <div className="w-full">
                <TableGeneral
                    loading={isLoading}
                    column={columnsUpdateHours}
                    state={backups}
                    pagination={{ position: ["topLeft", "topLeft"], pageSize: 5 }}
                    tableProps={propsUpdateHours}
                />
            </div>
        </CardProjectFiche>
    );
};

export default CardUpdatedHours;
